import { animate, keyframes, style, transition, trigger } from '@angular/animations';
import { Component } from '@angular/core';

@Component({
  selector: 'icon-backward',
  standalone: true,
  template: `
    <button type="button" class="btn-backward" (click)="playClick()" aria-label="Backward">

      @if(state === 'idle'){
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M16 26.5C14.75 26.5 13.5792 26.2625 12.4875 25.7875C11.3958 25.3125 10.4458 24.6708 9.6375 23.8625C8.82917 23.0542 8.1875 22.1042 7.7125 21.0125C7.2375 19.9208 7 18.75 7 17.5H9C9 19.45 9.67917 21.1042 11.0375 22.4625C12.3958 23.8208 14.05 24.5 16 24.5C17.95 24.5 19.6042 23.8208 20.9625 22.4625C22.3208 21.1042 23 19.45 23 17.5C23 15.55 22.3208 13.8958 20.9625 12.5375C19.6042 11.1792 17.95 10.5 16 10.5H15.85L17.4 12.05L16 13.5L12 9.5L16 5.5L17.4 6.95L15.85 8.5H16C17.25 8.5 18.4208 8.7375 19.5125 9.2125C20.6042 9.6875 21.5542 10.3292 22.3625 11.1375C23.1708 11.9458 23.8125 12.8958 24.2875 13.9875C24.7625 15.0792 25 16.25 25 17.5C25 18.75 24.7625 19.9208 24.2875 21.0125C23.8125 22.1042 23.1708 23.0542 22.3625 23.8625C21.5542 24.6708 20.6042 25.3125 19.5125 25.7875C18.4208 26.2625 17.25 26.5 16 26.5ZM13 20.5V16H11.5V14.5H14.5V20.5H13ZM16.5 20.5C16.2167 20.5 15.9792 20.4042 15.7875 20.2125C15.5958 20.0208 15.5 19.7833 15.5 19.5V15.5C15.5 15.2167 15.5958 14.9792 15.7875 14.7875C15.9792 14.5958 16.2167 14.5 16.5 14.5H18.5C18.7833 14.5 19.0208 14.5958 19.2125 14.7875C19.4042 14.9792 19.5 15.2167 19.5 15.5V19.5C19.5 19.7833 19.4042 20.0208 19.2125 20.2125C19.0208 20.4042 18.7833 20.5 18.5 20.5H16.5ZM17 19H18V16H17V19Z" fill="#0B2C2D"/>
        </svg>
      }

      @if(state === 'active'){
        <svg @rotateOnEnter width="32" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
          <mask id="mask0_29_4086" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="4" y="4" width="25" height="24">
            <rect x="28.25" y="28" width="24" height="24" transform="rotate(-180 28.25 28)" fill="#D9D9D9"/>
          </mask>
          <g mask="url(#mask0_29_4086)">
            <path d="M17.25 5.99995C18.0833 6.08328 18.8833 6.28745 19.65 6.61245C20.4166 6.93745 21.15 7.36662 21.85 7.89995L20.45 9.34995C19.9666 8.99995 19.4541 8.71662 18.9125 8.49995C18.3708 8.28328 17.8166 8.13328 17.25 8.04995L17.25 5.99995ZM15.25 5.99995L15.25 8.04995C13.5166 8.29995 12.0833 9.07912 10.95 10.3874C9.81662 11.6958 9.24995 13.2166 9.24995 14.9499C9.24995 16.8999 9.92912 18.5541 11.2875 19.9125C12.6458 21.2708 14.3 21.95 16.25 21.95L16.45 21.95L14.85 20.35L16.25 18.95L20.25 22.95L16.25 26.95L14.85 25.5L16.4 23.95L16.25 23.95C15 23.95 13.8291 23.7124 12.7375 23.2374C11.6458 22.7624 10.6958 22.1208 9.88745 21.3124C9.07912 20.5041 8.43745 19.5541 7.96245 18.4624C7.48745 17.3708 7.24995 16.1999 7.24995 14.9499C7.24995 12.6666 8.00829 10.6791 9.52495 8.98745C11.0416 7.29578 12.95 6.29995 15.25 5.99995ZM23.3 9.34995C23.8333 10.05 24.2625 10.7833 24.5875 11.55C24.9125 12.3166 25.1166 13.1166 25.2 13.95L23.15 13.95C23.0666 13.3833 22.9166 12.8291 22.7 12.2875C22.4833 11.7458 22.2 11.2333 21.85 10.75L23.3 9.34995ZM25.2 15.95C25.1 16.8 24.8916 17.6166 24.575 18.4C24.2583 19.1833 23.8333 19.9 23.3 20.55L21.85 19.15C22.2 18.6666 22.4833 18.1541 22.7 17.6125C22.9166 17.0708 23.0666 16.5166 23.15 15.95L25.2 15.95Z" fill="#1C6E70"/>
          </g>
        </svg>
      }

    </button>
  `,
  styles: [`
    .btn-backward {
      appearance: none;
      background: transparent;
      border: 0;
      padding: 0;
      line-height: 0;
      cursor: pointer;
    }
    svg path { 
      fill: #000; transition: fill .2s; 
    }

    button:hover svg path { 
      fill: var(--main-color, #0B2C2D); 
    }
  `],
  animations: [
    trigger('rotateOnEnter', [
      transition(':enter', [
        animate('200ms ease-out', keyframes([
          style({ transform: 'rotate(-180deg)', offset: 0 }),
          style({ transform: 'rotate(-360deg)', offset: 1 })
        ]))
      ])
    ])
  ],
})
export class BackwardIconComponent {
  private timer?: number;
  public state: 'idle' | 'active' = 'idle';

  playClick() {
    window.clearTimeout(this.timer);
    this.state = 'active';
    this.timer = window.setTimeout(() => {
      this.state = 'idle';
    }, 450);
  }
}